/*
 * Ryan O'Dowd
 * 2025-07-09
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

// @TODO: yeet most of these
const getStyles = ({globalScale, colors}) => {
  return {
    diffWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: 4,
      maxWidth: '100%',
    },
    currentText: {
      display: 'inline',
      overflowWrap: 'anywhere',
      backgroundColor: `${colors.alert}44`,
    },
    newText: {
      display: 'inline',
      overflowWrap: 'anywhere',
      backgroundColor: `${colors.accentDark}44`,
    },
    diffText: {
     display: 'inline',
    },
    diffChar: {
     display: 'inline',
    },
    addedChar: {
      backgroundColor: `${colors.accentDark}aa`,
    },
    removedChar: {
      backgroundColor: `${colors.alert}aa`,
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 4,
    },
    teacherNameAndActions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 4,
    },
    bulkActionsWrapper: {
      backgroundColor: colors.primaryExtraLight,
      padding: 8,
      borderRadius: globalScale * 8,
    },
  };
};

export default getStyles;
